import type { PaymentsActivityTranslations } from "../interfaces/paymentsActivity";

export const paymentsActivityTranslations: PaymentsActivityTranslations = {
  // Page
  page_title: "Actividad de pagos",
  page_subtitle: "Ingresos y envíos procesados en tiempo real",
  page_eyebrow: "Monitor en vivo",
  live_updated_at: "Actualizado {{time}}",
  live_refresh_aria: "Actualizar la lista",

  stats_total: "Total",
  stats_processing: "En proceso",
  stats_settled: "Liquidadas",
  stats_failed: "Fallidas",
  stats_page_scope: "En esta página",

  // Direction tabs
  tab_payins: "Ingresos",
  tab_payouts: "Envíos",

  // Filters
  filter_status_label: "Estado",
  filter_all_statuses: "Todos los estados",
  filter_corridor_label: "Corredor",
  filter_all_corridors: "Todos los corredores",
  filter_date_label: "Periodo",
  filter_all_dates: "Todo el historial",
  filter_last_days: "Últimos {{days}} días",
  filter_clear: "Limpiar filtros",

  // Status labels — one per raw backend status value (see STATUS_LABEL_KEYS); shared by pill + filter.
  status_value_created: "Pendiente",
  status_value_pending: "En proceso",
  status_value_confirmed: "Acreditado",
  status_value_rejected: "Rechazado",
  status_value_failed: "Fallido",
  status_value_reversed: "Revertido",
  status_value_processing: "En proceso",
  status_value_paid: "Pagado",
  status_value_cancelled: "Cancelado",

  // Table
  table_th_status: "Estado",
  table_th_corridor: "Corredor",
  table_th_amount: "Monto (neto)",
  table_th_reference: "Referencia",
  table_th_date: "Fecha",
  list_group_today: "Hoy",
  list_group_yesterday: "Ayer",
  pagination_summary: "Mostrando {{from}}–{{to}} de {{total}}",
  copy_reference_aria: "Copiar",
  copy_success: "Copiado al portapapeles",

  // Empty / error
  empty_title: "Aún no hay movimientos",
  empty_description: "Cuando proceses un ingreso o un envío aparecerá aquí con su estado en vivo.",
  empty_filtered_description: "No hay movimientos para los filtros seleccionados.",
  error_load: "No pudimos cargar la actividad.",
  error_retry: "Reintentar",

  // Drawer
  drawer_title_payin: "Detalle del ingreso",
  drawer_title_payout: "Detalle del envío",
  drawer_failure_reason: "Motivo",
  drawer_section_qr: "Cobrar",
  drawer_section_amounts: "Montos",
  drawer_amount_gross: "Monto bruto",
  drawer_amount_fees: "Comisiones",
  drawer_amount_net: "Monto neto",
  drawer_section_timeline: "Historial de estado",
  drawer_view_ledger: "Ver asientos contables",
  deeplink_not_found:
    "No se pudo abrir la operación enlazada: puede que ya no exista, que pertenezca a otra organización o que el enlace apunte al tipo equivocado.",
  deeplink_dismiss: "Entendido",
  drawer_section_details: "Detalles",
  drawer_meta_id: "ID",
  drawer_meta_reference: "Referencia",
  drawer_meta_concept: "Concepto",
  drawer_meta_beneficiary: "Destinatario",
  drawer_meta_breb_key: "Llave Bre-B",
  drawer_meta_breb_network_reference: "ID de transacción Bre-B",
  drawer_meta_created: "Creado",
  drawer_meta_expires: "Expira",
  drawer_meta_updated: "Actualizado",
  drawer_meta_evidence: "Comprobante",
  drawer_meta_evidence_open: "Abrir",

  // Timeline
  timeline_step_created: "Creado",
  timeline_step_processing: "En proceso",
  timeline_step_credited: "Acreditado",
  timeline_step_paid: "Pagado",
  timeline_step_failed: "Fallido",
  timeline_step_cancelled: "Cancelado",
  timeline_source_staff: "Equipo Coloca",
  timeline_source_network: "Red de pagos",
  timeline_source_system: "Sistema",
  scope_title: "Filtrado desde Métricas",
  scope_all_organizations: "Todas las organizaciones",
  scope_window_completed: "Confirmadas o pagadas del {{from}} al {{to}}",
  scope_window_created: "Creadas del {{from}} al {{to}}",
  scope_clear: "Quitar este filtro",
};
